import { FILTER_TYPES } from '@common/Filters/constants/filterTypes';

const FILTERS_WRAP_CLASSES = {
    hidden: 'filters-list-item__dropdown filters-list-item__dropdown--hidden',
    hasDesktopFiltersUpdate: 'filters-list-item__list',
    [FILTER_TYPES.brand]: 'filters-list-item__dropdown brand-list-wrapper',
    [FILTER_TYPES.sortBy]: 'filters-list-item__dropdown sortby-column-wrapper',
    [FILTER_TYPES.size]: 'filter-column-wrapper',
    [FILTER_TYPES.productSeries]: 'filters-list-item__dropdown scroll-list-wrapper product-series-wrapper',
    default: 'filter-column-wrapper'
};

export const getWrapperClassName = ({
    isExpanded,
    dropdownLeft
}) => {
    if (!isExpanded) {
        return FILTERS_WRAP_CLASSES.hidden;
    }

    if (dropdownLeft) {
        return `${FILTERS_WRAP_CLASSES.hasDesktopFiltersUpdate}
           ${FILTERS_WRAP_CLASSES.hasDesktopFiltersUpdate}--dropdown-left`;
    }

    return FILTERS_WRAP_CLASSES.hasDesktopFiltersUpdate;
};
